/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 05-11-2026 12:02:02

export enum Cijferkolomtype {
    TOETS = "Toets",
    ADVIES = "Advies",
    LAATSTE_PERIODEGEMIDDELDE = "Laatste periodegemiddelde",
    LAATSTE_GEMIDDELDE = "Laatste gemiddelde",
    LAATSTE_RAPPORTCIJFER = "Laatste rapportcijfer",
    PERIODEGEMIDDELDE = "Periodegemiddelde",
    GEMIDDELDE = "Gemiddelde",
    RAPPORTCIJFER = "Rapportcijfer",
    SE_CIJFER = "SE-cijfer",
    CE_CIJFER = "CE-cijfer",
    EINDCIJFER = "Eindcijfer"
}
